/* Copyright 2013 - 2024 Waiterio LLC */
import { Navigate } from 'react-router'

export const paths = ['/']

const HomeRedirect = () => <Navigate exact to="/takeaway" />

export default HomeRedirect
